<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="6">
        <v-card>
          <v-card-title class="teal lighten-5">
            Session Details
            <v-spacer/>
            <v-btn
              outlined
              color="danger"
              @click="deleteDialog = true"
            >
              <v-icon>delete</v-icon>
              Delete session
            </v-btn>
          </v-card-title>
          <v-card-text>
            <session-form
              v-model="sessionForm"
            />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="saveSession"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" lg="6">
        <v-card>
          <v-toolbar class="elevation-0">
            <v-toolbar-title>Trainees</v-toolbar-title>
            <v-spacer />
            <v-btn
              outlined
              color="primary"
              @click="addTrainee"
            >
              <v-icon>add</v-icon>
              Add Trainee
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      MSA Person ID
                    </th>
                    <th class="text-left">
                      Name
                    </th>
                    <th class="text-left">
                      Member Number
                    </th>
                    <th class="text-left">
                      Assessments
                    </th>
                    <th class="text-end">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="trainee in session.trainees"
                    :key="trainee._id"
                  >
                    <td>{{ _.get(trainee, 'person.personId') }}</td>
                    <td>{{ _.get(trainee, 'person.name') }}</td>
                    <td>{{ trainee.memberNumber }}</td>
                    <td>{{ _.get(trainee, 'person.assessments.length', 0) }}</td>
                    <td class="text-end">
                      <v-btn small icon @click="editTrainee(trainee)">
                        <v-icon color="primary">edit</v-icon>
                      </v-btn>
                      <v-btn small icon @click="showAssessments(trainee)">
                        <v-icon color="primary">assessment</v-icon>
                      </v-btn>
                      <v-btn small icon @click="promptRemoveTrainee(trainee)">
                        <v-icon color="danger">delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="assessmentDialog"
      width="1000"
    >
      <v-card v-if="selectedTrainee">
        <v-card-title>
          Assessments for {{ selectedTrainee.person.name }}
        </v-card-title>

        <v-card-text>
          <trainee-assessment-list
            :personId="selectedTrainee.personId"
            :sessionId="id"
            v-bubble.error
            v-bubble.info
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="assessmentDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="addTraineeDialog"
      width="1000"
    >
      <v-card>
        <v-card-title>
          Add Trainee
        </v-card-title>
        <v-card-text>
          <v-switch
            v-model="newPerson"
            label="Add new Person"
          />
          <person-search-field
            v-show="!newPerson"
            v-model="traineeForm.personId"
            v-bubble.error
            :exclude="session.trainees.map(o => o.personId)"
          />
          <person-form
            v-show="newPerson"
            v-model="personForm"
          />
          <v-text-field
            label="Member number"
            name="memberNumber"
            v-model="traineeForm.memberNumber"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="saveTrainee"
          >
            Save
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="addTraineeDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editTraineeDialog"
      width="1000"
    >
      <v-card>
        <v-card-title>
          {{ personForm.name }}
        </v-card-title>
        <v-card-text>
          <person-form
            v-model="personForm"
            @valid="personValid = $event"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="savePerson"
            :disabled="!personValid"
          >
            Save
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="editTraineeDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      width="400"
    >
      <v-card>
        <v-card-title>
          Delete Training Session
        </v-card-title>
        <v-card-text>
          Are you sure?
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="danger"
            text
            @click="deleteSession"
          >
            Delete
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="deleteDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="removeTraineeDialog"
      width="400"
    >
      <v-card>
        <v-card-title>
          Remove Trainee {{ _.get(traineeForm, 'person.name') }}
        </v-card-title>
        <v-card-text>
          Are you sure?
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="danger"
            text
            @click="removeTrainee"
          >
            Remove
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="removeTraineeDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import gql from 'graphql-tag'

import SessionForm from '../components/forms/SessionForm.vue'
import TraineeAssessmentList from '../components/TraineeAssessmentList.vue'
import PersonForm from '../components/forms/PersonForm.vue'
import PersonSearchField from '../components/inputs/PersonSearchField.vue'

export default {
  name: 'AdminTrainingSessionView',

  components: {
    SessionForm,
    TraineeAssessmentList,
    PersonForm,
    PersonSearchField
  },

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data: () => ({
    sessionForm: {},
    session: {
      trainees: []
    },
    assessmentDialog: false,
    selectedTrainee: null,
    deleteDialog: false,
    addTraineeDialog: false,
    newPerson: false,
    editTraineeDialog: false,
    traineeForm: {},
    personForm: {},
    removeTraineeDialog: false,
    personValid: false
  }),

  apollo: {
    session: {
      query: gql`query TrainingSessionDetails($id: MongoID!) {
        session: trainingSessionById(_id: $id) {
          _id
          scheduledDate
          completionDate
          venue
          moduleId
          trainingUnitCodes
          module {
            _id
            code
            units {
              _id
              code
            }
          }
          trainerId
          trainer {
            _id
            person {
              _id
              name
            }
          }
          trainees {
            _id
            memberNumber
            personId
            person {
              _id
              personId
              isTrainee
              isActive
              email
              name
              givenName
              familyName
              phoneNumber
              assessments (filter: { sessionId: $id }, limit: 0) {
                _id
                sessionId
                personId
                unitCode
                assessment
                passed
              }
            }
          }
        }
      }`,
      variables () {
        return {
          id: this.id
        }
      },
      error (e) { this.onError(e) },
      result ({ data }) {
        if (!data) return
        const { session } = data
        this.sessionForm = Object.assign({}, session)
      }
    }
  },

  methods: {
    onError (e) {
      this.$emit('error', e)
    },

    addTrainee () {
      this.newPerson = false
      this.traineeForm = {}
      this.personForm = {}
      this.addTraineeDialog = true
    },

    editTrainee (trainee) {
      this.traineeForm = Object.assign({}, trainee)
      this.personForm = Object.assign({}, trainee.person)
      this.editTraineeDialog = true
    },

    async saveTrainee () {
      try {
        if (this.newPerson) {
          const person = await this.$apollo.mutate({
            mutation: gql`mutation ($record: CreateOnePersonInput!) {
              personCreateOne(record: $record){
                recordId
              }
            }`,
            variables: {
              id: this.traineeForm.personId,
              record: {
                email: this.personForm.email,
                name: this.personForm.name,
                givenName: this.personForm.givenName,
                familyName: this.personForm.familyName,
                phoneNumber: this.personForm.phoneNumber
              }
            }
          })
          this.traineeForm.personId = person.data.personCreateOne.recordId
        }
        await this.$apollo.mutate({
          mutation: gql`mutation ($id: MongoID!, $personId: MongoID!, $record: TrainingSessionTraineesInput!, $person: UpdateByIdPersonInput!) {
            trainingSessionPushTrainee(_id: $id, record: $record) { _id },
            personUpdateById(_id: $personId, record: $person){
              record {
                _id
                isTrainee
                isActive
              }
            }
          }`,
          variables: {
            id: this.session._id,
            personId: this.traineeForm.personId,
            record: {
              personId: this.traineeForm.personId,
              memberNumber: this.traineeForm.memberNumber
            },
            person: {
              isTrainee: true,
              isActive: true
            }
          }
        })
      } catch (e) {
        this.onError(e)
        return
      }
      this.addTraineeDialog = false
      this.$apollo.queries.session.refresh()
    },

    async savePerson () {
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation ($id: MongoID!, $record: UpdateByIdPersonInput!) {
            personUpdateById(_id: $id, record: $record){
              record {
                _id
                isTrainee
                isActive
                email
                name
                givenName
                familyName
                phoneNumber
              }
            }
          }`,
          variables: {
            id: this.traineeForm.personId,
            record: {
              isTrainee: true,
              isActive: true,
              email: this.personForm.email,
              name: this.personForm.name,
              givenName: this.personForm.givenName,
              familyName: this.personForm.familyName,
              phoneNumber: this.personForm.phoneNumber
            }
          }
        })
      } catch (e) {
        this.onError(e)
        return
      }
      this.editTraineeDialog = false
      this.$apollo.queries.session.refresh()
    },

    showAssessments (trainee) {
      this.selectedTrainee = trainee
      this.assessmentDialog = true
    },

    promptRemoveTrainee (trainee) {
      this.traineeForm = Object.assign({}, trainee)
      this.removeTraineeDialog = true
    },

    async removeTrainee () {
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation ($id: MongoID!, $traineeId: MongoID!) {
            trainingSessionRemoveTrainee(_id: $id, traineeId: $traineeId) { _id }
          }`,
          variables: {
            id: this.id,
            traineeId: this.traineeForm._id
          }
        })
      } catch (e) {
        this.onError(e)
        return
      }
      this.$apollo.queries.session.refresh()
      this.removeTraineeDialog = false
    },

    async deleteSession () {
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation ($id: MongoID!) {
            trainingSessionRemoveById(_id: $id) { recordId }
          }`,
          variables: {
            id: this.id
          }
        })
      } catch (e) {
        this.onError(e)
        return
      }

      this.$router.push({ name: 'AdminTrainingSessionList' })
    },

    async saveSession () {
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation ($id: MongoID!, $record: UpdateByIdTrainingSessionInput!) {
          trainingSessionUpdateById(_id: $id, record: $record) { recordId }
        }`,
          variables: {
            id: this.id,
            record: {
              moduleId: this.sessionForm.moduleId,
              trainingUnitCodes: this.sessionForm.trainingUnitCodes,
              trainerId: this.sessionForm.trainerId,
              venue: this.sessionForm.venue,
              scheduledDate: this.sessionForm.scheduledDate,
              completionDate: this.sessionForm.completionDate
            }
          }
        })
      } catch (e) {
        this.onError(e)
        return
      }
      this.$emit('info', 'Session saved')
    }
  }
}
</script>
